$(function() {
    'use strict';
	$('body').append(`
			<div class="show-modal-restaurant-slider"></div>
	`);
    const DAYS_OF_THE_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    const InStoreContainer = $('#restaraunt_attributes_hours #instore');
    const PickupContainer = $('#restaraunt_attributes_hours #pickup');
    const DeliveryContainer = $('#restaraunt_attributes_hours #delivery');
    
    let userPermissions = $('#userPermissions').val();
     var userid  = $('#userId').val();
    /*if(userPermissions && (userPermissions.includes("PlateRate Admin") || userPermissions.includes("Restaurant Admin") || userPermissions.includes("Salesperson"))){*/
    if(userid){
      //console.log("userPermissions for additionalDetails++++++++++",userPermissions);
    
    }else{
      $('#restaurantFeaturesAdd, #collapseOwnershipType #ownerType, #restaurantOwnershipOptions, #drink_happy_hour_bar_keys, #ownerTypep, #byobnotetext, #age-delivery-person, #deliver-alcohol, #bottomless_boozy_brunch_bar_keys, #collapseSeatingCapacity input.seatInput, .payOption, #collapseDressCode .dressSelect, #collapseByob .byob-radio-btn').prop('disabled', true);
      $('#saveByob, .btn-edit-time,#rest-set-time-multiple-days').hide(); 
      $('#saveSeat').hide();
    }
    
    $("#slider-romantic").slider({ 
        range: "min",
        value: 1,
        min: 1,
        max: 100
    });

    $("#slider-service").slider({
        range: "min",
        value: 1,
        min: 1,
        max: 100
    });

    $("#slider-ambience").slider({
        range: "min",
        value: 1,
        min: 1,
        max: 100
    });

    $("#slider-noise").slider({
        range: "min",
        value: 1,
        min: 1,
        max: 100
    });

    //save venueId for later use
    const  venueId = $('#venue-id').text().trim();

    var winWidth = ($(window).width());
    if (winWidth <= 400) {
        $(".daySize").removeClass("col-xs-2");
        $(".daySize").addClass("col-xs-1");
    } else if (winWidth > 400) {
        $(".daySize").removeClass("col-xs-1");
        $(".daySize").addClass("col-xs-2");
    }

    get_restaurant_hours() /* this is needed on top, since the hours are displayed in rest header part */
    /**init load additional detail, needed for only restaurant page, not advanced search */
    var initAdditionalDetail = function() {
        getAwardsDataInNewsfeed(); //this is defined in awardFunctions.js
        getMood();
        getCapacity();
        getBYOB();
        getCorkage();
        getAwards();
        getDressCode();
        getOwnerType();
        getOwnerTypeOptions();
        getPayOps();
        getFeatures();
    }
    var initAdditionalDetailRestaurant = function() {
        initAdditionalDetail();
        getTimeVenue();
        fillDataAttributes(); 
    }
    
    $('body').on('click', '.additional-accordion', function(){
        $(this).removeClass('additional-accordion');
        console.log("addiitonla details accordion clicked");
        initAdditionalDetailRestaurant();
    })

    $('body').on('click', '#venueHoursLink-set-hour', function(){
        let header_height = $('#header').height();
        if(!$('#restaurant-about').is(':visible')){
          $(`.open-restaurant-about`).trigger('click');
        }
        $(`#restaurant-infor-collapse`).collapse('show');
        $(`#collapsefour`).collapse('show');
        $(`#collapseRestrauntHours`).collapse('show');
        $('html, body').animate({ scrollTop: $(`#collapseRestrauntHours`).offset().top - header_height }, 800);
    })
    
    $('body').on('click', '#iManageRestaurant', function(event){
        event.preventDefault()
        window.stop();
        window.location.href="/restaurants"
    });

    $('body').on('click', '#referPlaterate', function() {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to encourage this restaurant to partner with PlateRate?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: "#3cb371",
            cancelButtonColor: "#b30000",
            allowOutsideClick: true,
        }).then((result) => {
            if (result.isConfirmed) {
                let venueId = $("#venueId").val();
                $.ajax({
                    url: '/salescrm/requestrestaurant',
                    method: 'POST',
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify({
                        venueId: venueId
                    }),
                    dataType: 'json',
                    error: function (err) {
                        Swal.fire({
                            title: "Request error !!!",
                            text: 'Please try again!',
                            icon: "error",
                            confirmButtonText: "Yes",
                            allowOutsideClick: true,
                        });
                    },
                    success: function (res) {
                        Swal.fire({
                            title: "Request success",
                            text: 'PlateRate will try to work with this restaurant',
                            icon: "success",
                            confirmButtonText: "Yes",
                            allowOutsideClick: true,
                        });
                    }
                });
            }
        });
    });    

    function getMood () {
        $.ajax({
            url: '/getMood',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError,
            success: function(data) {
                try {
                    $("#slider-romantic").slider('value', data.mood.romantic);
                    $("#slider-service").slider('value', data.mood.service);
                    $("#slider-ambience").slider('value', data.mood.ambience);
                    $("#slider-noise").slider('value', data.mood.noise);
                } catch (error) {
                    logError();
                }
            }
        });
    }

    //ajax to get seating capacity
    function getCapacity () {
        $.ajax({
            url: '/getCapacity',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError,
            success: function(data) {
                try {
                    if(data.capacity && (data.capacity.venue || data.capacity.table || data.capacity.group || data.capacity.seat)) $("#saveSeat").prop('disabled', true).text('Saved');
                    document.getElementById("venueSeating").value = data.capacity.venue;
                    document.getElementById("tableSeating").value = data.capacity.table;
                    document.getElementById("groupSeating").value = data.capacity.group;
                    document.getElementById("seatingCapacity").value = data.capacity.seat;
                } catch (error) {
                    logError();
                }
            }
        });
    }

    //ajax to get corkage fee
    function getCorkage() {
        $.ajax({
            url: '/getCorkage',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError,
            success: function(data) {
                try {
                    if (data && data.corkage && data.corkage.fee) $("#corkage").val(data.corkage.fee);
                    if (data && data.byobNotes) $("#byobnotetext").val(data.byobNotes);
                    if (data && data.corkageOtherDays && data.corkageOtherDays.notAllowed === "true") {
                        $('#BYOBNotAllowed').prop('checked', true);
                        $('#corkageotherdays').prop("disabled",true);
                    } else if (data && data.corkageOtherDays && data.corkageOtherDays.fee) {
                            $("#corkageotherdays").val(data.corkageOtherDays.fee);
                    }
                    
                } catch (error) {
                    logError();
                }
            }
        });
    }


    // ajax call to get byob

    function getBYOB() {
        $.ajax({
            url: '/getBYOB',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError
        })
        .then(loadBYOB);
    }

    function loadBYOB(data) {
        if (data && data.byobAllowed === "Yes") {
            $('.byobYes').prop('checked', true);
            $('#corkageotherdays_all').removeClass('hide');
            $('#corkageFeeOption').show();
            try {
                if (data.byobDays.mon === 'true') {
                    $('#BYOBMon').toggleClass('unselected');
                    $('#BYOBMon').toggleClass('btn-success');
                    $('#BYOBMon').toggleClass('selected');
                    $('#byobmonday').val('true');
                    
                }
                if (data.byobDays.tue === 'true') {
                    $('#BYOBTues').toggleClass('unselected');
                    $('#BYOBTues').toggleClass('btn-success');
                    $('#BYOBTues').toggleClass('selected');
                    $('#byobtuesday').val('true');
                }
                if (data.byobDays.wed === 'true') {
                    $('#BYOBWed').toggleClass('unselected');
                    $('#BYOBWed').toggleClass('btn-success');
                    $('#BYOBWed').toggleClass('selected');
                    $('#byobwednesday').val('true');
                }
                if (data.byobDays.thu === 'true') {
                    $('#BYOBThur').toggleClass('unselected');
                    $('#BYOBThur').toggleClass('btn-success');
                    $('#BYOBThur').toggleClass('selected');
                    $('#byobthursday').val('true');
                }
                if (data.byobDays.fri === 'true') {
                    $('#BYOBFri').toggleClass('unselected');
                    $('#BYOBFri').toggleClass('btn-success');
                    $('#BYOBFri').toggleClass('selected');
                    $('#byobfriday').val('true');
                }
                if (data.byobDays.sat === 'true') {
                    $('#BYOBSat').toggleClass('unselected');
                    $('#BYOBSat').toggleClass('btn-success');
                    $('#BYOBSat').toggleClass('selected');
                    $('#byobsaturday').val('true');
                }
                if (data.byobDays.sun === 'true') {
                    $('#BYOBSun').toggleClass('unselected');
                    $('#BYOBSun').toggleClass('btn-success');
                    $('#BYOBSun').toggleClass('selected');
                    $('#byobsunday').val('true');
                }
            } catch (e) {
                // console.log('no user data');
            }
        } else {
            $('.byob-days-container').hide();
            $('.byobNo').prop('checked', true);
            $('#corkageotherdays_all').addClass('hide');
            $('#corkageFeeOption').hide();
        }
    }
    // ajax call to get awards data
	function getAwardsDataFromVenue(defaultValue) {
	$.ajax({
            url: '/getAwards',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError,
	success:function (data){
		defaultValue(data); 
	}
        });
    }
    function getAwards() {
    //console.log("getting awards for venueid...",venueId);
		$.ajax({
            url:'/getAwardsLookupData/'+venueId,
            method: 'GET',
            dataType: 'json',
            data: { venueId:venueId},
            error: logError,
			success:function(awardList){
			  //console.log("getAwardsData...",awardList);
				
			if(awardList){
				getAwardsDataFromVenue(function(output){
					var awardsVenueObject = output.awards;
					var awardsMasterObject = JSON.parse(awardList.data);
					if(awardsMasterObject && awardsMasterObject.length>0)
					{
						var i = 1;
						var awardDataLength = awardsMasterObject.length;
						var awardsData = '<div class="container text-center" id="awardDataUpdate">';
						var c = 1;
						var rowFlag = 1;
                        var selectedValue=0;  
						awardsMasterObject.forEach((item) => {
							if(awardsVenueObject){

                            //compare master options index with index from venue, in loop
                            let awardNameMaster = $.trim(item.awardName.toLowerCase());
                            let awardsNameVenueArray = Object.keys(awardsVenueObject);
									for(var num =0;num<awardsNameVenueArray.length;num++){  

									if(awardNameMaster.replace(/ /g,'') == $.trim(awardsNameVenueArray[num].toLowerCase())){
                                        let awardSelectedIndex =  awardsVenueObject[awardsNameVenueArray[num]];
										selectedValue = parseInt(awardSelectedIndex);
									}
							}
                        }

							
							if(c == 1){
								awardsData += '<div class="row">'; //adding wrapper  div  for every 3 award elements
								rowFlag=1;
                            }
                             var isDefualtSelected = !parseInt(selectedValue) ? 'selected':' ';
						     var optionList = '<option value="0" '+isDefualtSelected+'>Select</option>';
							let awardConvetDetaTyppe = item.awardValue.toString();
							 var  itemAwardValue =  awardConvetDetaTyppe.split(',');
							for (var k = 0; k < itemAwardValue.length; k++) {
                                //create dropdown options list
								var selecetd = (k+1)==parseInt(selectedValue) ? 'selected':'';
								optionList += '<option value="'+(k+1)+'" '+selecetd+'>'+itemAwardValue[k]+'</option>';
                            
                            }
							//append awards
							awardsData+='<div class="col-md-4 form-inline col-12" style="justify-content: space-between;"><label class="'+item._id+'">'+item.awardName+'</label><span class="custom-dropdown"><select id="'+item._id+'" class="awardSelect awardSelectRestaurant" style="width:100px">'+optionList+'</select></span></div>';
							if((c==3 && rowFlag==1) || (i==awardDataLength && rowFlag==1)){ 
								awardsData += '</div>'; //close wrapper div
								rowFlag=0;
								c=0;
							}
							c=c+1;
							if(i==awardDataLength){
								awardsData += '</div>';
                                    $("#collapseShowAwards").html(awardsData);
                var userid  = $('#userId').val();
                if(userid){
                  // console.log("userPermissions++++++++++",userPermissions);
                }else{
                    $('#awardDataUpdate span select.awardSelect').prop('disabled', true);
                }
							}
							i++;

						  selectedValue=0;
                        })
					}
				});
			}
			}
        });
    }

    //ajax call to dress code

    function getDressCode() {
        $.ajax({
            url: '/getDressCode',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError
        })
        .then(loadDressCode);

    }

    function loadDressCode(data) {
        try {
          let criteria = [];
          if(data.dressIndex.index > 0) criteria.push(data.dressIndex.index);
          if(data.dressIndex.index2 > 0) criteria.push(data.dressIndex.index2);
            document.getElementById("lunchSelect").selectedIndex = data.dressIndex.index;
            document.getElementById("dinnerSelect").selectedIndex = data.dressIndex.index2;
          if(criteria.length > 0) $("#dressCode").html('('+criteria.length +' Criteria)');
          else $("#dressCode").html('');
        } catch (e) {
            logError();
        }
    }

    //ajax call to owner type

    function getOwnerType () {
        $.ajax({
            url: '/getOwnerType',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError
        })
        .then(loadOwnerType);

    }

    function loadOwnerType(data) {
        try {
            $('#ownerType option:eq(' + data.ownerIndex.index + ')').prop('selected', true);
        } catch (e) {
            logError();
        }
    }


    //ajax call to get OwnerTypeOptions
    function getOwnerTypeOptions() {
        $.ajax({
            url: '/getOwnerTypeOptions',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError
        })
        .then(loadOwnerTypeOptions);

    }
		
		function loadOwnerTypeOptions(data) {
        if(data && data.ownerIndexOptions){
         let selectedOwnerTypeVal=data.ownerIndexOptions.split(",");
	        if($('#restaurantOwnershipOptions').length){
	          $('#element').select2('destroy');
				    $('#restaurantOwnershipOptions').val(selectedOwnerTypeVal).select2();
				    $('#restaurantOwnershipOptions').select2({
					    placeholder: "Select Restaurant Ownership",
				    });
	        }
	      }
    }		
		

    //ajax call to get    options
    function getPayOps () {
        $.ajax({
            url: '/getPayOps',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError
        })
        .then(loadPayOps);
    }

    function loadPayOps(data) {
        try {
          if(userPermissions && (userPermissions.includes("PlateRate Admin") || userPermissions.includes("Restaurant Admin") || userPermissions.includes("Salesperson"))){
            if (data.payOptions.amex === 'true') {
                $('input[id=payAmex]').prop('checked', true);
            } else {
                $('input[id=payAmex]').prop('checked', false).removeAttr('checked');
            }
            if (data.payOptions.mastercard === 'true') {
                $('input[id=payMastercard]').prop('checked', true);
            } else {
                $('input[id=payMastercard]').prop('checked', false).removeAttr('checked');
            }
            if (data.payOptions.cash === 'true') {
                $('input[id=payCash]').prop('checked', true);
            } else {
                $('input[id=payCash]').prop('checked', false).removeAttr('checked');
            }
            if (data.payOptions.credit === 'true') {
                $('input[id=payCredit]').prop('checked', true);
            } else {
                $('input[id=payCredit]').prop('checked', false).removeAttr('checked');
            }
            if (data.payOptions.visa === 'true') {
                $('input[id=payVisa]').prop('checked', true);
            } else {
                $('input[id=payVisa]').prop('checked', false).removeAttr('checked');
            }
            if (data.payOptions.discover === 'true') {
                $('input[id=payDiscover]').prop('checked', true);
            } else {
                $('input[id=payDiscover]').prop('checked', false).removeAttr('checked');
            }
          }else{
//to a normal user or not logged in, show only enabled values.
            if (data.payOptions.amex === 'true') {
                $('input[id=payAmex]').parent().hide();
            } else {
                $('#rest-payAmex-li').hide();
            }
            if (data.payOptions.mastercard === 'true') {
                $('input[id=payMastercard]').parent().hide();
            } else {
                $('#rest-payMastercard-li').hide();
            }
            if (data.payOptions.cash === 'true') {
                $('input[id=payCash]').parent().hide();
            } else {
                $('#rest-payCash-li').hide();
            }
            if (data.payOptions.credit === 'true') {
                $('input[id=payCredit]').parent().hide();
            } else {
                $('#rest-payCredit-li').hide();
            }
            if (data.payOptions.visa === 'true') {
                $('input[id=payVisa]').parent().hide();
            } else {
                $('#rest-payVisa-li').hide();
            }
            if (data.payOptions.discover === 'true') {
                $('input[id=payDiscover]').parent().hide();
            } else {
                $('#rest-payDiscover-li').hide();
            }
          } 
        } catch (e) {
            logError();
        }
    }

    //ajax call to get features
    function getFeatures() {
        $.ajax({
            url: '/getFeatures',
            method: 'GET',
            dataType: 'json',
            data: { venueId: venueId },
            error: logError
        })
        .then(loadFeatures);

    }
    function loadFeatures(data) {
    //console.log("in loadFeatures...",data);
      let criterias = [];
       let selectedFeaturesVal=[];
        try {
            if (data.features.one === 'true') {
              selectedFeaturesVal.push("one");
                criterias.push(1);
            }
            if (data.features.two === 'true') {
              selectedFeaturesVal.push("two");
                criterias.push(2);
            }
            if (data.features.three === 'true') {
              selectedFeaturesVal.push("three");
                criterias.push(3);
            }
            if (data.features.four === 'true') {
              selectedFeaturesVal.push("four");
                criterias.push(4);
            }
            if (data.features.five === 'true') {
              selectedFeaturesVal.push("five");
                criterias.push(5);
            }
            if (data.features.six === 'true') {
              selectedFeaturesVal.push("six");
                criterias.push(6);
            }
            if (data.features.seven === 'true') {
              selectedFeaturesVal.push("seven");
                criterias.push(7);
            }
            if (data.features.eight === 'true') {
              selectedFeaturesVal.push("eight");
                criterias.push(8);
            }
            if (data.features.nine === 'true') {
              selectedFeaturesVal.push("nine");;
                 criterias.push(9);
            }
            
            if (data.features.ten === 'true') {
              selectedFeaturesVal.push("ten");
                criterias.push(10);
                $("#bottomless_boozy_brunch_label").show();
            }

            if (data.features.eleven === 'true') {
              selectedFeaturesVal.push("eleven");
                 criterias.push(11);
                 $("#drink_happy_hour_label").show();
            }
            if (data.features.twelve === 'true') {
              selectedFeaturesVal.push("twelve");
                criterias.push(12);
                $("#secret_restaurant_label").show();
            }
            if (data.features.thirteen === 'true') {
                selectedFeaturesVal.push("thirteen");
                criterias.push(12);
                $("#themed_restaurant_label").show();
            }
            if(criterias.length > 0){ 
              $("#res_features").html('('+ criterias.length +' Criteriaq)');
              $("#featureLen").val(criterias.length);
            }  
            else {
              $("#res_features").html('q');
              $("#featureLen").val(0);
            }
        } catch (e) {
            // console.log('no user data');
        }
	    if($('#restaurantFeaturesAdd').length){
	      $('#element').select2('destroy');
		  $('#restaurantFeaturesAdd').val(selectedFeaturesVal).select2();
	    }
    }

    /**Edit venue hours handler */
    $('.edit-venue-hours').on('click', function(event) {
        event.preventDefault();
        //hide this container
        $(event.target.parentNode.parentNode).hide();
        //Show the edit hours container
        $(event.target.parentNode.parentNode.parentNode)
        .find('.edit-hours-container').show();
    });

    //ajax call to get time table hours
    function getTimeVenue() {
        $.ajax({
            url: '/getTime/' + venueId,
            method: 'GET',
            dataType: 'json',
            error: logError,
            success: loadHours
        });
    }
    function get_restaurant_hours(){
        let data = {
            venueId: venueId
        }
        $.ajax({
            url: '/restaurant-hours',
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(data),
        })
        .then((res)=>{
            if(!_.size(res.data)) {
                $('.current-open').text('Closed');
                $('.label-open-time').text('');
                return
            }
            __venue_hours = res.data;
            let d = new Date();
            let n = d.getDay();
            let hours = res.data[n];
            if(!hours) {
                $('.current-open').text('Closed');
                $('.label-open-time').text('');
                return
            }
            // Check if restaurant is closed for this day
            if(hours.isClose === true) {
                $('.current-open').text('Closed');
                $('.label-open-time').text('');
                return
            }
            if(hours && hours.open && hours.close){
              if(hours.open) $('.current-open').text(moment(hours.open, 'HH:mm A').format("hh:mm A"));
              if(hours.close) $('.current-close').text(' - ' + moment(hours.close, 'HH:mm A').format("hh:mm A"));
            }else{
                $('.current-open').text('Closed');
                $('.label-open-time').text('');
                return
            }
            if(!hours.altOpen) return
            $('.current-altOpen').text("ALT. HOURS: " + moment(hours.altOpen, 'HH:mm A').format("hh:mm A"));
            $('.current-altClose').text(' - ' + moment(hours.altClose, 'HH:mm A').format("hh:mm A"));  
        })
        .catch((err)=>{

        })

    }
    //load hours if available, for venue
    function loadHours(venueHours) {
        try {
                if (venueHours) {
                    let currentDay = today();
                    for (var day in venueHours) {
                        $('.' + day + '-open').text('Closed');


                        let openHour = (venueHours[day].open ? venueHours[day].open.slice(0, 2): 'Select'),
                            openMin = (venueHours[day].open ? venueHours[day].open.slice(3, 5): '00'),
                            openAMPM = (venueHours[day].open ? venueHours[day].open.slice(5, 7): 'AM');

                        let closeHour = (venueHours[day].close ? venueHours[day].close.slice(0, 2): 'Select'),
                            closeMin = (venueHours[day].close ? venueHours[day].close.slice(3, 5): '00'),
                            closeAMPM = (venueHours[day].close ? venueHours[day].close.slice(5, 7): 'PM');

                        let altOpenHour = (venueHours[day].altOpen ?  venueHours[day].altOpen.slice(0, 2): 'Select'),
                            altOpenMin = (venueHours[day].altOpen ? venueHours[day].altOpen.slice(3, 5): '00'),
                            altOpenAMPM = (venueHours[day].altOpen ? venueHours[day].altOpen.slice(5, 7): 'AM');

                        let altCloseHour = (venueHours[day].altClose ? venueHours[day].altClose.slice(0, 2): 'Select'),
                            altCloseMin = (venueHours[day].altClose ? venueHours[day].altClose.slice(3, 5): '00'),
                            altCloseAMPM = (venueHours[day].altClose  ? venueHours[day].altClose.slice(5, 7): 'PM');

                        //sets select boxes to reflect stored times
                        $("." + day + ".openSelect.day-hours-select").val(openHour);
                        $("." + day + ".openSelect.day-hours-select.mins").val(openMin);
                        $("." + day + ".openSelect.day-hours-select.ampm").val(openAMPM);

                        $("." + day + ".closeSelect.day-hours-select").val(closeHour);
                        $("." + day + ".closeSelect.day-hours-select.mins").val(closeMin);
                        $("." + day + ".closeSelect.day-hours-select.ampm").val(closeAMPM);

                        $("." + day + ".altOpen.day-hours-select").val(altOpenHour);
                        $("." + day + ".altOpen.day-hours-select.mins").val(altOpenMin);
                        $("." + day + ".altOpen.day-hours-select.ampm").val(altOpenAMPM);

                        $("." + day + ".altClose.day-hours-select").val(altCloseHour);
                        $("." + day + ".altClose.day-hours-select.mins").val(altCloseMin);
                        $("." + day + ".altClose.day-hours-select.ampm").val(altCloseAMPM);

                        // Check if restaurant is closed for this day
                        if (venueHours[day].isClose === true) {
                            $('.' + day + '-open').text('Closed');
                            $('.' + day + '-close').text('');
                            $('.' + day + '-alt-hours-container').hide();
                            if(currentDay === day) {
                                $('.current-open').text('Closed');
                                $('.label-open-time').text('');
                            }
                        } else if (venueHours[day].isOpen) {
                            if(currentDay === day) {
                                // $('.current-open').text((venueHours[day].open ? venueHours[day].open : ''));
                                // $('.current-close').text((venueHours[day].close ? " - " + venueHours[day].close : ''));
                                // if (venueHours[day].altOpen || venueHours[day].altClose) {
                                //     if (venueHours[day].open != venueHours[day].altOpen && venueHours[day].close != venueHours[day].altClose) {
                                //         $('.current-altOpen').text((venueHours[day].altOpen ? "ALT. HOURS: " + venueHours[day].altOpen : "" ));
                                //         $('.current-altClose').text((venueHours[day].altClose ? " - " + venueHours[day].altClose : ""));
                                //     }
                                // }

                                let open = venueHours[day].open;
                                let close = venueHours[day].close;
                                let altOpen = venueHours[day].altOpen;
                                let altClose = venueHours[day].altClose;
                                checkIfOpen(open, close, altOpen, altClose);
                            }

                            $('.' + day + '-open').text(venueHours[day].open ? venueHours[day].open + ' - ': 'No primary hours set');
                            $('.' + day + '-close').text(venueHours[day].close  ? venueHours[day].close : '');
                            if (venueHours[day].altOpen || venueHours[day].altClose) {
                                if(venueHours[day].open != venueHours[day].altOpen && venueHours[day].close != venueHours[day].altClose){
                                    $('.' + day + '-altOpen').text(venueHours[day].altOpen ? venueHours[day].altOpen + ' - ':'');
                                    $('.' + day + '-altClose').text(venueHours[day].altClose ? venueHours[day].altClose : '');
                                    $('.' + day + '-alt-hours-container').show();
                                }
                            }
                        } else {
                            $('.' + day + '-alt-hours-container').hide();
                        }
                        if (venueHours[day].dayClose && !isDayClose) {
                            setVenuesHours(day, true)
                        }

                }
            } else {
                $('.venue-hours').hide();
                $('#no-hours-container').show();
            }
        } catch (e) {
            logError(e);
        }
    }
    
    //BYOB Days on click
    $("#BYOBSun, #BYOBMon, #BYOBTues, #BYOBWed, #BYOBThur, #BYOBFri, #BYOBSat").on('click',function(){
      if(!$(this).hasClass('selected')){
        $(this).parent('div').children('input[type=hidden]').val('true');
        
      }
    })
    
    


    function today() {
        var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var d = new Date();
        var dayName = days[d.getDay()];
        return dayName;
    }

    function logError(error) {
        // console.log('no user data');
    }

    function postError(error) {
        console.log('something broke when posting');
    }

    // ***************************************************

    function render_images_slider(elem){
      let html = '';
      elem.each(function(ind ,item){
        let imageUrl = $(item).find('img').attr('src');
         html+=  `
            <div class="carousel-item  text-center ${$(item).hasClass('active')?'active': ''}">
                <img loading="lazy" class="carousel-image" src="${imageUrl}" style="max-height: 700px; margin: 0 auto;" alt="Item Image">
            </div>`;
        })
      return html;
  }

  function collectionHas(a, b) { //helper function (see below)
    for(var i = 0, len = a.length; i < len; i ++) {
        if(a[i] == b) return true;
    }
    return false;
}
function findParentBySelector(elm, selector) {
    var all = document.querySelectorAll(selector);
    var cur = elm.parentNode;
    while(cur && !collectionHas(all, cur)) { //keep going up until you find a match
        cur = cur.parentNode; //go up
    }
    return cur; //will return null if not found
}



//   var elements = document.querySelectorAll("#imageCarousel, .images-of-menu-item, .slider-menus .carousel-inner")
//     for (var i = 0; i < elements.length; i++) {
//         elements[i].addEventListener('click', (e)=>{ 

//         let parentElem = findParentBySelector(e.target, ".images-of-menu-item")
//         let itemId = parentElem.dataset.itemId
//         let showBtn='';
//             if(itemId && itemId!=undefined ){ 
//                 showBtn=`<a href="javascript:void(0);" type="button" id="item_add_to_card" class="btn" data-item-id="${itemId}">Add to cart</a>` ;
//             }else{
//                 showBtn =`<a href="javascript:void(0);" type="button" id="see_restaurant_menu" class="btn">See Menu</a>`;
//             }
//         let elem = $("#"+parentElem.id).children().children();

//         let html = `
//         <div id="modal-restaurant-images" class="modal" role="dialog" style="top: 15%;">
//                 <div class="modal-dialog" style="max-width:750px;">
                
//                 <div id="carousel-menu-item" class="images-of-menu-item carousel slide" data-ride="carousel" style="${window.innerWidth > 480 ? '' : 'width: 100%'}">
                    
//                     <div style=" position: absolute; top: 2%; right: 2%; z-index: 999;">
//                     <button type="button" class="close btn" data-dismiss="modal" style="">×</button>
//                     </div>
//                     <div class="carousel-inner">

//                     <div class="carousel-inner">
//                         ${render_images_slider(elem)}
//                     </div>

//                     <a class="carousel-control-prev" href="#carousel-menu-item" data-slide="prev" role="button">
//                     <span class="carousel-control-prev-icon" aria-hidden="true"></span>
//                     <span class="sr-only">Previous</span>
//                     </a>
//                     <a class="carousel-control-next" href="#carousel-menu-item" data-slide="next" role="button">
//                     <span class="carousel-control-next-icon" aria-hidden="true"></span>
//                     <span class="sr-only">Next</span>
//                     </a>
//                 </div>
                
//                 </div>
//                 <div class="text-center">
//                     ${showBtn}
//                 </div>
//                 </div>
//             </div>
//         `;
//         $(".show-modal-restaurant-slider").html(html);
//         $("#modal-restaurant-images").modal('show');
//         }, true);
//     }
    //link to set venue hours if none exist for today
    $("#venueHoursLink").click(function(event){
        $('#collapsefour').attr("class", "in");
        $(document).scrollTop( $(".hours-container").offset().top );
    });
    
    
     //Change values of attributes  
     let featureArr = [];
     let total_attr;
     
    $('.feature').on("click", function(e) {    
      let featureLen = $("#featureLen").val();
      if($(this).hasClass("unSelect") == true){
        featureArr.push($(this).hasClass("unSelect"));
        if(featureLen){
          total_attr = +1 +  +featureLen;
        } else {
          total_attr = featureArr.length;
        }
       if(total_attr > 0){
          $("#res_features").html("("+total_attr+" Criteria)");
          $("#featureLen").val(total_attr);
        } else {
           $("#res_features").html("");
          $("#featureLen").val(0);
        } 
      } else {
        var unselected_value = [];
        if($(this).hasClass("unSelect") == false){
          unselected_value.push($(this).hasClass("unSelect"));
          total_attr = Number(featureLen) - Number(unselected_value.length);
          if(total_attr > 0){
            $("#res_features").html("("+total_attr+" Criteria)");
            $("#featureLen").val(total_attr);
            featureArr.splice(1,1);
            if(featureArr.length == '1') featureArr.pop();
          } else {
             $("#res_features").html("");
            $("#featureLen").val(0);
          }  
        } 
      }
      
    });
    
    $("#venueSeating,#groupSeating,#tableSeating,#seatingCapacity").on("change",function(){
      let venueSeat = $("#venueSeating").val();
      let groupSeat = $("#groupSeating").val();
      let tableSeat = $("#tableSeating").val();
      let seatingcapacity = $("#seatingCapacity").val();
      let critcount = 0;
      if(venueSeat != '' && venueSeat != 0) critcount++;
      if(groupSeat != '' && groupSeat != 0) critcount++;
      if(tableSeat != '' && tableSeat != 0) critcount++;
      if(seatingcapacity != '' && seatingcapacity != 0) critcount++;
      if(critcount>0){
        $("#capacity_types").html("("+critcount+" Criteria)");
      } else {
        $("#capacity_types").html("");
      } 
    })
    
    //the count of unchecked is shown for criteria for payment
     $("#payAmexid, #payCardid, #payCashid, #payVisaid, #payDiscoverid, #payMasterCardid").change(function() {
        var data =  [];
        if($('#payAmexid:checked').val() == undefined)  data.push($('#payAmexid:checked').val())	        
        if($('#payMasterCardid:checked').val() == undefined)  data.push($('#payMasterCardid:checked').val())	
        if($('#payCardid:checked').val() == undefined)  data.push($('#payCardid:checked').val())	
        if($('#payCashid:checked').val() == undefined)  data.push($('#payCashid:checked').val())	
        if($('#payVisaid:checked').val() == undefined)  data.push($('#payVisaid:checked').val())
        if($('#payDiscoverid:checked').val() == undefined)  data.push($('#payDiscoverid:checked').val())
        if(data && data.length > 0) $("#payOptions").html("("+data.length+" Criteria)");	  
        else $("#payOptions").html("");
     });
    
    $("#ownerType,#manOwned,#womanOwned").change(function() {
      let data = [];
      if($('#womanOwned:checked').val()) data.push('womanOwned');
      if($('#manOwned:checked').val()) data.push('manOwned');
      if($('#ownerType').val()) data.push('ownerType');
      if(data && data.length > 0) $("#ownerShipTypes").html('('+ data.length +' Criteria)');
      else $("#ownerShipTypes").html('');
      
      if($(this).attr('id') == "manOwned" || $(this).attr('id') == "womanOwned"){
        $("#ownershipBox").addClass('open');
      }
    });
     var data =  [];
    var selctedName=[];
    $(document).on('change', '#toggleAwards select', function(){
        var selctedId='#'+this.id;
       // console.log("this====", selctedName.indexOf(this.id));
        if(selctedName.indexOf(this.id) == -1) {
            selctedName.push(this.id);
            if($('#toggleAwards '+selctedId).val() && $('#toggleAwards '+selctedId).val() !='0')  data.push($('#toggleAwards '+selctedId).val())
           // console.log("data.length=="+data);      
            if(data && data.length > 0) $("#showAwards").html("("+data.length+" Criteria)");
            else $("#showAwards").html("");
        }
    })
    
    $("#lunchSelect, #dinnerSelect").on("change",function(){
      if($("#lunchSelect").val() !='' && $("#dinnerSelect").val() !=''){
        $("#dressCode").html("(2 Criteria)");
      } else if($("#lunchSelect").val() =='' && $("#dinnerSelect").val() !='' || $("#lunchSelect").val() !='' && $("#dinnerSelect").val() =='') {
        $("#dressCode").html("(1 Criteria)");
      }else {
        $("#dressCode").html("");
      }
    })
    
    
    $("#corkage,#corkageotherdays, #byobno, #byobyes").on("change",function(){
      let byob = $("input[name='BYOB']:checked").val();
      let critcount=0;
      if(byob == 'Yes') critcount++;
      if($("#corkage").val() !='' && $("#corkage").val() !='0') critcount++;
      if($("#corkageotherdays").val() != '' && $("#corkageotherdays").val() !='0') critcount++;
      if(critcount>0) {
        $("#byobSelected").html('('+critcount+' Criteria)');
      }
      else {
        $("#byobSelected").html('');
      }
    })
    
    
    /* additional features section Bunty, why this
    $(document).on('click', '#featuresBox, #paymentBox', function (e) {
      e.stopPropagation();
    });
*/
  $("#restaurantFeaturesAdd").on("change", function(e) {
	postpost();
  });
  
   //Change values of attributes  
   //let featureArr = [];
   //let total_attr;
   
  $('#restaurantFeatures').on("select2:selecting", function(e) {  
  let featureLen = $("#featureLen").val() ? $("#featureLen").val() : '0';
    featureArr.push(e.params.args.data.text);
    if(featureLen >= 0){
      total_attr = +featureArr.length +  +featureLen;
    } else if($("#featureLen").val() == undefined){
      total_attr = +featureArr.length + 1;
    } else {
      total_attr = featureArr.length;
    }
   if(total_attr > 0){
      $("#res_features").html("("+total_attr+" Criteria)");
    } else {
       $("#res_features").html("");
    }
  });

  $('#restaurantFeatures').on("select2:unselecting", function(e) {
    var unselected_value = $('#restaurantFeatures').val();
    var index = unselected_value.indexOf(e.params.args.data.text);
    var index2 = featureArr.indexOf(e.params.args.data.text);
    if (index !== -1) unselected_value.splice(index, 1);
    if (index2 !== -1) featureArr.splice(index2, 1);
    total_attr = Number(unselected_value.length);

    if(total_attr > 0){
      $("#res_features").html("("+total_attr+" Criteria)");
    } else {
       $("#res_features").html("");
    }
  });  
  
  $('#owner_Type').on("select2:selecting", function(e) {  
  let featureLen = $("#ownerShip-len").val() ? $("#ownerShip-len").val() : '0';
    featureArr.push(e.params.args.data.text);
    if(featureLen >= 0){
      total_attr = +featureArr.length +  +featureLen;
    } else if($("#ownerShip-len").val() == undefined){
      total_attr = +featureArr.length + 1;
    } else {
      total_attr = featureArr.length;
    }
   if(total_attr > 0){
      $("#ownerShipTypes").html("("+total_attr+" Criteria)");
    } else {
       $("#ownerShipTypes").html("");
    }
  });

  $('#owner_Type').on("select2:unselecting", function(e) {
    var unselected_value = $('#owner_Type').val();
    var index = unselected_value.indexOf(e.params.args.data.text);
    var index2 = featureArr.indexOf(e.params.args.data.text);
    if (index !== -1) unselected_value.splice(index, 1);
    if (index2 !== -1) featureArr.splice(index2, 1);
    total_attr = Number(unselected_value.length);

    if(total_attr > 0){
      $("#ownerShip-len").html("("+total_attr+" Criteria)");
    } else {
       $("#ownerShip-len").html("");
    }
  });

    function postpost() {
        var getVenueId = $('#venue-id').text().trim();
        if(check_login("#restaurantFeaturesAdd") == false){
            return;
        }
        if(getVenueId){
		var data = {
		    venueId: getVenueId,
		    one: false,
		    two: false,
		    three: false,
		    four: false,
		    five: false,
		    six: false,
		    seven: false,
		    eight: false,
		    nine: false,
			ten: false,
			eleven: false,
			twelve: false,
            thirteen: false
		};

	let selectedval = $("#restaurantFeaturesAdd").val();
		if (selectedval.indexOf("one")!=-1) {
		    data.one = true;
		}

		if (selectedval.indexOf("two")!=-1) {
		    data.two = true;
		}

		if (selectedval.indexOf("three")!=-1) {
		    data.three = true;
		}

		if (selectedval.indexOf("four")!=-1) {
		    data.four = true;
		}

		if (selectedval.indexOf("five")!=-1) {
		    data.five = true;
		}

		if (selectedval.indexOf("six")!=-1) {
		    data.six = true;
		}

		if (selectedval.indexOf("seven")!=-1) {
		    data.seven = true;
		}
		if (selectedval.indexOf("eight")!=-1) {
		    data.eight = true;
		}
		if (selectedval.indexOf("nine")!=-1) {
		    data.nine = true;
		}
		if (selectedval.indexOf("ten")!=-1) {
		    data.ten = true;
		}
		if (selectedval.indexOf("eleven")!=-1) {
		    data.eleven = true;
        }
        if (selectedval.indexOf("twelve")!=-1) {
            data.twelve = true;
        }
        if (selectedval.indexOf("thirteen")!=-1) {
            data.thirteen = true;
        }

		$(".tagContainer").change(function(e) {
		  let selected = $(".select2-container--default .select2-selection--multiple .select2-selection__rendered").text().split("×")
      
      $("#secret_restaurant_label").hide();
      $("#drink_happy_hour_label").hide();
      $("#bottomless_boozy_brunch_label").hide();
      $("#themed_restaurant_label").hide();
      
		  for(let i =0; i<selected.length; i++){
        if (selected[i] === "Bottomless Boozy Brunch") {
          $("#bottomless_boozy_brunch_label").show();
        }else if(selected[i] === "All You Can Drink Happy Hour"){
           $("#drink_happy_hour_label").show();
        }else if(selected[i] === "Hidden/Secret Restaurant/Bar"){
           $("#secret_restaurant_label").show();
        }else if(selected[i] === "Themed Restaurant"){
            $("#themed_restaurant_label").show();
         }
		  }
		});

		$.ajax({
		        url: '/postFeatures',
		        method: 'POST',
		        dataType: 'json',
		        data: data,
		        error: featurePostError
		    })
		    .then(success =>{
		        toastr.success("Save success");
		    })
		    .catch(error =>{
		        toastr.error("Save failed");
		    });
	} //venueid exists
    }
		
 	function postOwnershipOptions() {
		var getVenueId = $('#venue-id').text().trim();
		if(check_login("#restaurantOwnershipOptions") == false){
				return;
		}
	    if(getVenueId){
			let selectedval = $("#restaurantOwnershipOptions").val();
			//console.log("selectedval restaurantOwnershipOptions....",selectedval);
			var data =  {
                    data: selectedval.join(","),
                    venueId: getVenueId, 
                  };
			$.ajax({
							url: '/postOwnerTypeOptions',
							method: 'POST',
							contentType: "application/json; charset=utf-8",
							data: JSON.stringify(data),
							error: featurePostError
					})
					.then(success =>{
							toastr.success("Save success");
					})
					.catch(error =>{
							toastr.error("Save failed");
					});
			} //venueid exists
    }
	
    $(".payOption").change(function() {
        var data = {
            venueId: $('#venue-id').text().trim(),
            amex: $('input[id=payAmex]').prop('checked'),
            mastercard: $('input[id=payMastercard]').prop('checked'),
            credit: $('input[id=payCredit]').prop('checked'),
            cash: $('input[id=payCash]').prop('checked'),
            visa: $('input[id=payVisa]').prop('checked'),
            discover: $('input[id=payDiscover]').prop('checked')
        };
        
        if(data.venueId){
          $.ajax({
                  url: '/postPayOps',
                  method: 'POST',
                  dataType: 'json',
                  data: data,
                  error: featurePostError
              })
              .then(success =>{
                  if(success && success.ok == 1){
                    toastr.success("Save success");
                  } else {
                    toastr.error("Save failed");
                  }
                  saveLogRestaurant("Paymant Options",$(this).attr('id'),$(this).prop('checked') ? "Off": "On",$(this).prop('checked') ? "On": "Off");
              })
              .catch(error =>{
                  toastr.error("Save failed");
              });
          }
    });

    // I oumou, added this block of code to complete the functionality of woman and minority owned checkboxes
    // the #ownerTypeOption id is the id of the div element where my checkboxes are in the file add_restaurant_detail.ejs

    	$("#restaurantOwnershipOptions").on("change", function(e) {
				postOwnershipOptions();
			});

    $("#slider-romantic").slider({
        slide: function(event, ui) {
            $('#saveRomantic').show();
        }
    });
    $("#slider-service").slider({
        slide: function(event, ui) {
            $('#saveService').show();
        }
    });
    $("#slider-ambience").slider({
        slide: function(event, ui) {
            $('#saveAmbience').show();
        }
    });
    $("#slider-noise").slider({
        slide: function(event, ui) {
            $('#saveNoise').show();
        }
    });

     $("#ownerType").change(function() {
        if(check_login("#ownerType") == false){
            return;
        }
        var data = {
            venueId: $('#venue-id').text().trim(),
            ownerIndex: $("#ownerType").prop('selectedIndex')
        };
        if(data.venueId){

          $.ajax({
                  url: '/postOwnerType',
                  method: 'POST',
                  dataType: 'json',
                  data: data,
                  error: featurePostError
              })
              .then(donePostOwner);
        }
    });

    // Dress Code

    $(".dressSelect").change(function() {
        if(check_login(".dressSelect") == false){
            return;
        }
        var data = {
            venueId: $('#venue-id').text().trim(),
            index: $("#lunchSelect").prop('selectedIndex'),
            index2: $("#dinnerSelect").prop('selectedIndex')

        };
        if(data.venueId){

          $.ajax({
              url: '/postDressCode',
              method: 'POST',
              dataType: 'json',
              data: data,
              error: featurePostError
          })
          .then(success =>{
              toastr.success("Save success");
          })
          .catch(error =>{
              toastr.error("Save failed");
          });
        }
    });
    
    $('body').on('click', '#awardDataUpdate select', function() {
        if(check_login('#awardDataUpdate select') == false){
            return;
        }
        let getSelectId = $(this).attr('id');    
        let awardValue =  $(this).children("option:selected").val();
        let getAwardName = $('#awardDataUpdate .'+getSelectId).text().trim();
        var updateAward = {
            venueId: $('#venue-id').text().trim(),
            [getAwardName]:awardValue
        };
        //console.log("isuser loggedin..",userIsLoggedIn);
        if(updateAward.venueId && userIsLoggedIn){
          $.ajax({
              url: '/postAwards',
              method: 'POST',
              dataType: 'json',
              data: updateAward,
              error: "not updated data"
          })
          .then(success =>{
              toastr.success("Save success");
          })
          .catch(error =>{
              toastr.error("Save failed");
          });
        }
    });
    $('.byob-radio-btn').on('change', function(e) {
        if(check_login('.byob-radio-btn') == false){
            return;
        }
        $("#byob_Div_id").addClass('open');
        var venueId = $('#venue-id').text().trim();
        var byobValue = $(e.target).val();

        if (byobValue === 'No') { 
            $('.byob-days-container').hide();
            $('#corkageotherdays_all').addClass('hide');
            $('#corkageFeeOption').hide();
        }
        else { 
            $('.byob-days-container').show();
            $('#corkageotherdays_all').removeClass('hide');
            $('#corkageFeeOption').show();
        }

        var data = {
            venueId : venueId,
            byobAllowed : byobValue
        };
        if(data.venueId){
          $.ajax({
              url: '/postBYOB',
              method: 'POST',
              dataType: 'json',
              data: data,
              error: featurePostError
          })
          .then(success =>{
              toastr.success("Save success");
          })
          .catch(error =>{
              toastr.error("Save failed");
          });
        }
    });

    if(document.getElementById("BYOBSun")) {
      document.getElementById("BYOBSun").onclick = function() {
        $('#BYOBSun').toggleClass('unselected');
        $('#BYOBSun').toggleClass('btn-success');
        $('#BYOBSun').toggleClass('selected');
        $("#byobsunday").val($('#BYOBSun').hasClass('selected'));
        saveBYOB();
      };
    }
    if(document.getElementById("BYOBMon")){
      document.getElementById("BYOBMon").onclick = function() {
        $('#BYOBMon').toggleClass('unselected');
        $('#BYOBMon').toggleClass('btn-success');
        $('#BYOBMon').toggleClass('selected');
        $("#byobmonday").val($('#BYOBMon').hasClass('selected'));
        saveBYOB();
      };
    }
    if(document.getElementById("BYOBTues")){
      document.getElementById("BYOBTues").onclick = function() {
        $('#BYOBTues').toggleClass('unselected');
        $('#BYOBTues').toggleClass('btn-success');
        $('#BYOBTues').toggleClass('selected');
        saveBYOB();
      };
    }
    if(document.getElementById("BYOBWed")) {
      document.getElementById("BYOBWed").onclick = function() {
        $('#BYOBWed').toggleClass('unselected');
        $('#BYOBWed').toggleClass('btn-success');
        $('#BYOBWed').toggleClass('selected');
        saveBYOB();
      };
    }
    if(document.getElementById("BYOBThur")) {
      document.getElementById("BYOBThur").onclick = function() {
        $('#BYOBThur').toggleClass('unselected');
        $('#BYOBThur').toggleClass('btn-success');
        $('#BYOBThur').toggleClass('selected');
        saveBYOB();
      };
    }
    if(document.getElementById("BYOBFri")) {
      document.getElementById("BYOBFri").onclick = function() {
        $('#BYOBFri').toggleClass('unselected');
        $('#BYOBFri').toggleClass('btn-success');
        $('#BYOBFri').toggleClass('selected');
        saveBYOB();
      };
    }
    if(document.getElementById("BYOBSat")) {
      document.getElementById("BYOBSat").onclick = function() {
        $('#BYOBSat').toggleClass('unselected');
        $('#BYOBSat').toggleClass('btn-success');
        $('#BYOBSat').toggleClass('selected');
        saveBYOB();
      };
    }

    function check_login(element = ''){
        var userid  = $('#userId').val();
        var venueId = $('#venue-id').text().trim();
        let trackey = '';
        if(element != ''){
           trackey = $(element).parents('.dropdown').find(".clickTrack").data('trackey');
        }
        //console.log("trackey",trackey);
        if(!userid && venueId ){
            Swal.fire({
                title: "Login Required",
                text: "Please login or register to edit restaurant features.",
                icon: "info",
                allowOutsideClick: true,
                confirmButtonText: "Login or Register",
                confirmButtonColor: "#3cb371",
            }).then((result) => {
                if (result.isConfirmed) {
                    sessionStorage.setItem("additionalRestaurant", trackey);
                    let urllogin = '/users/login';
                    if (window.location.pathname && (window.location.pathname !== urllogin && window.location.pathname !== '/')) {
                        urllogin = urllogin + '?next=' + window.location.pathname;
                    }
                    window.location.assign(urllogin);
                }
            });  
            return false;
        }else{
            return true;
        }
    }

    function saveBYOB(byobValue) {
        if(check_login("#saveByob") == false){
            return;
        }
        var data = {
            venueId: $('#venue-id').text().trim(),
            mon: $('#BYOBMon').hasClass('selected'),
            tue: $('#BYOBTues').hasClass('selected'),
            wed: $('#BYOBWed').hasClass('selected'),
            thu: $('#BYOBThur').hasClass('selected'),
            fri: $('#BYOBFri').hasClass('selected'),
            sat: $('#BYOBSat').hasClass('selected'),
            sun: $('#BYOBSun').hasClass('selected')
        };
        if(data.venueId){
          $.ajax({
              url: '/postBYOB',
              method: 'POST',
              dataType: 'json',
              data: data,
              error: featurePostError
          })
          .then(success =>{
              toastr.success("Save success");
          })
          .catch(error =>{
              toastr.error("Save failed");
          });
        }
    }
    //This is to show the save button in Corkage Fee $ and Corkage Fee of Other Days $ under the Additional Restaraunt Details accordion
    $('#corkage').on('focus', function (e) {
        $('#saveByob').show();
    });
    $('#corkage').on('change', function (e) {
        if (!$.trim($(this).val())) {
            $('#saveCorkage').hide();
        }
    });

    $('#corkageotherdays').on('focus', function (e) {
        $('#saveByob').show();
    });

    $('#corkageotherdays').on('change', function (e) {
        if (!$.trim($(this).val())) {
            $('#saveCorkageOtherDays').hide();
        }
    });

    $('#byobnotetext').on('focus', function(){
        $('#saveByob').show();
    })
    $('#byobnotetext').on('change', function () {
        if(!$.trim($(this).val())){
            $('#saveByobNote').hide();
        }
    })

	/****call to byod data save functions****/
	$("#saveByob").click((e) => {
        if(check_login("#saveByob") == false){
            return;
        }
		saveCorkage();
		saveCorkageOtherDays();
		saveByobNote();
	});
   
  function saveCorkage(){
        //e.preventDefault();
		var corkageFee = parseInt($('#corkage').val());
        if (isNaN(corkageFee)){
          corkageFee = null;
        }

        if ((corkageFee >= 0) || (corkageFee == null)) {
            $('#saveCorkage').hide();
            let cvenueid = $("#venue-id").text();
            if(cvenueid){
              $.ajax({
                  url: '/postCorkage',
                  method: 'POST',
                  dataType: 'json',
                  data: { venueId: $('#venue-id').text().trim(), corkage: corkageFee },
                  error: featurePostError
              })
              .then(success =>{
                  toastr.success("Save success");
              })
              .catch(error =>{
                  toastr.error("Save failed");
              });
            }
        } else {
            Swal.fire({
                title: "Number is invalid",
                text: "Please enter a positive number.",
                icon: "warning",
                allowOutsideClick: true,
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });  
        }

    };

//$("#saveCorkageOtherDays").on('click', function(e) {
	function saveCorkageOtherDays(){
		//e.preventDefault();
		var corkageFee = parseInt($('#corkage').val());
		var corkageFeeOther = parseInt($('#corkageotherdays').val());

		if (isNaN(corkageFeeOther)){
		  corkageFeeOther = null;
		}
		if (isNaN(corkageFee)){
		  corkageFee = null;
		}

		if (corkageFee >= 0 || corkageFee == null || corkageFeeOther >= 0 || corkageFeeOther == null ) {
		  var data = {
			  "venueId": $('#venue-id').text().trim(),
			  "corkageOtherDaysFee": corkageFeeOther,
			  "corkage": corkageFee,
		  };
			$('#saveByob').hide();
			$.ajax({
				url: '/postCorkage',
				method: 'POST',
				dataType: 'json',
				data: data,
				error: featurePostError
			});
		} else {
            Swal.fire({
                title: "Number is invalid",
                icon: "warning",
                allowOutsideClick: true,
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });  
		}
	};

    //$("#saveByobNote").click((e) => {
	function saveByobNote(){
        //e.preventDefault();
        var byobnotes = $.trim($('#byobnotetext').val());

        if (byobnotes.length < 500) {
            var data = {
                "venueId": $('#venue-id').text().trim(),
                "byobNotes": byobnotes
            };
            $('#saveByobNote').hide();
            if(data.venueId){
              $.ajax({
                  url: '/postCorkage',
                  method: 'POST',
                  data: data,
                  error: featurePostError
              })
              .then(success =>{
                  toastr.success("Save success");
              })
              .catch(error =>{
                  toastr.error("Save failed");
              });
            }
        } else {
            Swal.fire({
                title: "Maxlength character",
                text: "This field is maxlength 500 character",
                icon: "warning",
                allowOutsideClick: true,
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });   
        }
    }

    //Fix problem with clicking on Select input inside Boostrap dropdown list causes dropdown to close
    $('ul.dropdown-menu select').on('click', function(e) {
        e.stopPropagation();
    });

    //This is to disable the BYOB Other Days $ field in Additional Restaraunt Details
    $('#BYOBNotAllowed').on('click', function(e) {
        if(check_login('#BYOBNotAllowed') == false){
            return;
        }
        $('#corkageotherdays').prop("disabled",this.checked);

   // I oumou add the if and else statement of code to get the value stored in the session variable
   // of Cortage fee of others day $ that the user imputed before he check the not allowed
   //when the user uncheck the not allowed , the value we weote there before shoul apear again
        if(this.checked)
            $('#corkageotherdays').val("");
        else
        {
            //var corkageFeeOther and   var corkageotherdays are both session
            var corkageotherdays = sessionStorage.getItem('corkageotherdays');
            $('#corkageotherdays').val(corkageotherdays);
        }
        var data = {
            venueId: $('#venue-id').text().trim(),
            corkageOtherDaysNotAllowed: this.checked
        };
        if(data.venueId){
            $.ajax({
                url: '/postCorkage',
                method: 'POST',
                dataType: 'json',
                data: data,
                error: featurePostError
            })
            .then(success =>{
                toastr.success("Save success");
            })
            .catch(error =>{
                toastr.error("Save failed");
            });
          }
    });

    $(".seatInput").change(function(e) {
        $("#saveSeat").prop('disabled', false).text('Save');
    })

    $("#saveSeat").click(function(e) {
        if(check_login("#saveSeat") == false){
            return;
        }
        e.preventDefault();
        let $this = $(this);
        const data = {
            venueId: $('#venue-id').text().trim(),
            venue: document.getElementById('venueSeating').value,
            table: document.getElementById('tableSeating').value,
            group: document.getElementById('groupSeating').value,
            seat: document.getElementById('seatingCapacity').value
        };
        if(data.venueId){
          $.ajax({
              url: '/postCapacity',
              method: 'POST',
              dataType: 'json',
              contentType: 'application/json; charset=utf-8',
              data: JSON.stringify(data),
              success : function(data) {
                  $this.prop('disabled', true).text('Saved');
                  toastr.success("Save success");
              },
              error: function(err) {
                  $this.prop('disabled', false).text('Save');
                  toastr.error("Save failed");
              }
          })
        }
    });
    //This is to stop the user from saving Corkage Fee $ and Other Corkage Fee $ fields if the input is greater than $100
    $('#saveCorkage').on('click', function(e) {
        $('#corkageotherdays').prop("disabled",this.checked);
    });

    $("#romantic").change(function() {
        $('#saveRomantic').show();
    });

    $("#service").change(function() {
        $('#saveService').show();
    });
    $("#ambience").change(function() {
        $('#saveAmbience').show();
    });
    $("#noise_level").change(function() {
        $('#saveCapacity').show();
    });

    function donePostPay(data) {
        console.log('done posting pay options');
    }
    // I oumou did the next function to finish the functionality of the checkboses
    function donePostOwnerTypeOption(data) {
        console.log('done posting Owner Type Option');
    }//I oumou ended function

    function donePostOwner(data) {
        console.log('done posting pay options');
    }
    function donePostDress(data) {
        console.log('done posting dress options');
    }

    function postFeatures(data) {
        console.log('done posting features');
    }

    function featurePostError(error) {
        console.log('something broke when posting features', error);
    }


    $(document).ready(function(){
        $('[data-toggle="tooltip1"]').tooltip({
            placement : 'bottom',
            title:'The total number of people that can fit in this venue at one time.'
        });
        $('[data-toggle="tooltip2"]').tooltip({
            placement : 'bottom',
            title:'The total number of people in a single group that can be seated together/in the same part of the restaurant.'
        });
        $('[data-toggle="tooltip3"]').tooltip({
            placement : 'bottom',
            title:'The total number of people that can be seated at the same table.'
        });



    });

    $('.payOption_link').click(function(){
        if(check_login('.payOption_link') == false){
            return;
        }
        if($('input[id='+this.id+']').prop('checked')){
            $('input[id='+this.id+']').prop('checked',false);
            $(this).find('span').addClass('hide');
        }else {
            $('input[id='+this.id+']').prop('checked',true);
            $(this).find('span').removeClass('hide');
        }
        $('input[id='+this.id+']').trigger('change');
    });

    /**
     * Additional restaurant details - Restaurant Attributes - InStore Time, Pickup Time, Delivery
     */
    $('.set-for-order-type').on('click','li',function(){
        $(this).toggleClass('active')
    })

    $('.restaurant-set-time').on('click',function(){
        let time_infor =getSettingInfor();
        setTimeForAll(time_infor);
        if(!_.size(time_infor.order_type) || !_.size(time_infor.set_days)) {
            toastr.options = {
                "preventDuplicates": true,
                "positionClass": "toast-bottom-center",
            }
            toastr.error('Please select at least one Order Type and at least one Day in week!');
            return
        }
        setTimeout(() => {
            $('#set-time-for-multiple-days').collapse('hide');
        }, 1500);
        let order_type = time_infor.order_type[0];
        $('a[href$="'+order_type+'"]').trigger('click'); 
        if(!$(this).data('save')){
            $('#' + order_type).find('.btn-edit-time').trigger('click');
            return
        } 
        $('.btn-save-hours').trigger('click');
    });
    function getSettingInfor(){
        let order_type = [];
        $.each($('.set-for-order-type').find('li'),(index, item)=>{
            if($(item).hasClass('active')){
                order_type.push($(item).data('type'))
            }
        });
        let set_days = [];
        $.each($('.set-for-days').find('input'),(index, item)=>{
            set_days.push({
                day: $(item).data('day'),
                isClose: !$(item).prop('checked')
            });
        });
        let time_infor = {
            shift1 : {
                from : {
                    hours: $('.shift1-set-from-hours-for-all').val(),
                    minutes: $('.shift1-set-from-minutes-for-all').val(),
                    apm: $('.shift1-set-from-apm-for-all').val(),
                },
                to : {
                    hours: $('.shift1-set-to-hours-for-all').val(),
                    minutes: $('.shift1-set-to-minutes-for-all').val(),
                    apm: $('.shift1-set-to-apm-for-all').val(),
                }
            },
            shift2 : {
                from : {
                    hours: $('.shift2-set-from-hours-for-all').val(),
                    minutes: $('.shift2-set-from-minutes-for-all').val(),
                    apm: $('.shift2-set-from-apm-for-all').val(),
                },
                to : {
                    hours: $('.shift2-set-to-hours-for-all').val(),
                    minutes: $('.shift2-set-to-minutes-for-all').val(),
                    apm: $('.shift2-set-to-apm-for-all').val(),
                }
            }
        }
        let setting_infor = {
            order_type: order_type,
            set_days: set_days,
            time_infor: time_infor
        };
        return setting_infor
    }
    function toggleWeekdaySelection($component, day, shouldOpen){
        const $weekday = $component.find(`#${day}-week-day`);
        if(!$weekday.length) return;
        if(shouldOpen){
            $weekday.addClass('selected');
        } else {
            $weekday.removeClass('selected');
        }
    }
    function updateTimeSetterVisibility($component){
        const $timeSetter = $component.find(".time-setter");
        if(!$timeSetter.length) return;
        const totalWeekdayBtnSelected = $component.find(".weekday-label.selected");
        if(totalWeekdayBtnSelected.length){
            $timeSetter.show();
        } else {
            $timeSetter.hide();
        }
    }
    function setTimeForAll(data){
        _.forEach(data.order_type,(item)=>{
            let component = $(`#${item}`);
            _.forEach(data.set_days,(dayInfo)=>{
                const day = dayInfo.day;
                if(!day) return;
                const shouldOpen = !dayInfo.isClose;
                toggleWeekdaySelection(component, day, shouldOpen);
                _.forEach(['from','to'],(ele)=>{
                    component.find(`#open_${day}_${ele}_hours`).val(data.time_infor.shift1[ele].hours);
                    component.find(`#open_${day}_${ele}_minute`).val(data.time_infor.shift1[ele].minutes);
                    component.find(`#open_${day}_${ele}_ampm`).val(data.time_infor.shift1[ele].apm);

                    component.find(`#altOpen_${day}_${ele}_hours`).val(data.time_infor.shift2[ele].hours);
                    component.find(`#altOpen_${day}_${ele}_minute`).val(data.time_infor.shift2[ele].minutes);
                    component.find(`#altOpen_${day}_${ele}_ampm`).val(data.time_infor.shift2[ele].apm);

                    component.find(`#close_${day}_${ele}_hours`).val(data.time_infor.shift1[ele].hours);
                    component.find(`#close_${day}_${ele}_minute`).val(data.time_infor.shift1[ele].minutes);
                    component.find(`#close_${day}_${ele}_ampm`).val(data.time_infor.shift1[ele].apm);

                    component.find(`#altClose_${day}_${ele}_hours`).val(data.time_infor.shift2[ele].hours);
                    component.find(`#altClose_${day}_${ele}_minute`).val(data.time_infor.shift2[ele].minutes);
                    component.find(`#altClose_${day}_${ele}_ampm`).val(data.time_infor.shift2[ele].apm);
                })
                updateTimeSetterVisibility(component);
            })
        })
    }
    $('#restaraunt_attributes_hours').find('.nav-tabs').on('click', 'li', function() {
        $('.form-show-time').show();
        $('.form-edit-time').hide();
    })

    $('.btn-edit-time').on('click', function() {
      let $container = $('#restaraunt_attributes_hours');
        const typeId = $(this).data('id');
        const $parent = $('#' + typeId);
        $parent.find('.form-show-time').hide();
        $parent.find('.form-edit-time').show();
        if(typeId=='instore'){
            $container = $('#instore');
        }else if(typeId=='pickup'){
            $container = $('#pickup');
        }else {
            $container = $('#deliverys');
        }
        let selectedDays = $container.find(".weekday-label.selected"); 
        if(selectedDays && selectedDays.length>0){
          $container.find(".time-setter").show(); 
        }
    })

    $('.btn-cancel-hours').on('click', function() {
        const typeId = $(this).data('id');
        const $parent = $('#' + typeId);
        $parent.find('.form-show-time').show();
        $parent.find('.form-edit-time').hide();
        $(document).scrollTop( $("#collapseRestrauntHours").offset().top - 40 );
    })
 $('body').on('click', '.weekday-label', function (e) {
        $(this).toggleClass('selected');
        let $container = $("#restaraunt_attributes_hours");
        if($(this).hasClass("add-instore-time")){
          $container = $("#instore");
        }else if($(this).hasClass("add-pickup-time")){
          $container = $("#pickup");
        }else if($(this).hasClass("add-delivery-time")){
          $container = $("#deliverys");
        } else{
          $container = $(this).closest('.position-rel');
        }
        const totalWeekdayBtnSelected = $container.find(".weekday-label.selected");
        const $timeSetter = $container.find(".time-setter");
        if (totalWeekdayBtnSelected.length){
          $timeSetter.show();
        } else {
          $timeSetter.hide();
        }
    });
  $('body').on('click', '.multiple-time-apply', function (e) {
    let $container =  $("#restaraunt_attributes_hours");
    if($(this).hasClass("instore-rest-time")){
      $container =  $("#instore"); 
    }else if($(this).hasClass("pickup-rest-time")){
      $container =  $("#pickup"); 
    }else if($(this).hasClass("delivery-rest-time")){
      $container =  $("#deliverys"); 
    }else{
      $container = $(this).closest('.position-rel');
    }
    const $daySelected = $container.find(".weekday-label.selected");
    let daySelected = [];
    $.each($daySelected, (index, e) => {
      let $e = $(e);
      daySelected.push($e.data('day'));
    });
    let from_hour = $container.find(`.set_from_hour :selected`).text();
    let from_min  = $container.find(`.set_from_min :selected`).text();
    let from_ampm = $container.find(`.set_from_ampm :selected`).text();
    let to_hour   = $container.find(`.set_to_hours :selected`).text();
    let to_min    = $container.find(`.set_to_min :selected`).text();
    let to_ampm   = $container.find(`.set_to_ampm :selected`).text();
    let alt_from_hour = $container.find(`.alt_set_from_hour :selected`).text();
    let alt_from_min  = $container.find(`.alt_set_from_min :selected`).text();
    let alt_from_ampm = $container.find(`.alt_set_from_ampm :selected`).text();
    let alt_to_hour   = $container.find(`.alt_set_to_hours :selected`).text();
    let alt_to_min    = $container.find(`.alt_set_to_min :selected`).text();
    let alt_to_ampm   = $container.find(`.alt_set_to_ampm :selected`).text();

    daySelected.forEach((day, index) => {
        $container.find(`#open_${day}_from_hours`).val(from_hour);
        $container.find(`#open_${day}_from_minute`).val(from_min);
        $container.find(`#open_${day}_from_ampm`).val(from_ampm);
        $container.find(`#close_${day}_to_hours`).val(to_hour);
        $container.find(`#close_${day}_to_minute`).val(to_min);
        $container.find(`#close_${day}_to_ampm`).val(to_ampm);
        $container.find(`#altOpen_${day}_from_hours`).val(alt_from_hour);
        $container.find(`#altOpen_${day}_from_minute`).val(alt_from_min);
        $container.find(`#altOpen_${day}_from_ampm`).val(alt_from_ampm);
        $container.find(`#altClose_${day}_to_hours`).val(alt_to_hour);
        $container.find(`#altClose_${day}_to_minute`).val(alt_to_min);
        $container.find(`#altClose_${day}_to_ampm`).val(alt_to_ampm);
    });
  });

    $('.btn-save-hours').on('click', function(){
        if(check_login('.btn-save-hours') == false){
            return;
        }
        const typeId = $(this).data('id');
        const $parent = $('#' + typeId);
        let hours = {};
        let checkTime = false;
        DAYS_OF_THE_WEEK.forEach((day) => {
            let hours_open = $.trim($parent.find('#open_'+ day +'_from_hours').val());
            let minute_open = $.trim($parent.find('#open_'+ day +'_from_minute').val());
            let ampm_open = $.trim($parent.find('#open_'+ day +'_from_ampm').val());

            let hours_alt_open = $.trim($parent.find('#altOpen_'+ day +'_from_hours').val());
            let minute_alt_open = $.trim($parent.find('#altOpen_'+ day +'_from_minute').val());
            let ampm_alt_open = $.trim($parent.find('#altOpen_'+ day +'_from_ampm').val());

            let hours_close = $.trim($parent.find('#close_'+ day +'_to_hours').val());
            let minute_close = $.trim($parent.find('#close_'+ day +'_to_minute').val());
            let ampm_close = $.trim($parent.find('#close_'+ day +'_to_ampm').val());

            let hours_alt_close = $.trim($parent.find('#altClose_'+ day +'_to_hours').val());
            let minute_alt_close = $.trim($parent.find('#altClose_'+ day +'_to_minute').val());
            let ampm_alt_close = $.trim($parent.find('#altClose_'+ day +'_to_ampm').val());



            let _open = hours_open +':'+ minute_open + ampm_open;
            let _close = hours_close + ':' + minute_close + ampm_close;
            let _altOpen = hours_alt_open + ':' + minute_alt_open + ampm_alt_open;
            let _altClose = hours_alt_close + ':' + minute_alt_close + ampm_alt_close;

            // Check time open anh clode
            let ck_open     = newDateSlipt(_open);
            let ck_close    = newDateSlipt(_close);
            let ck_altOpen  = newDateSlipt(_altOpen);
            let ck_altClose = newDateSlipt(_altClose);

	    
            console.log("ck_open===",ck_open,ck_close,ck_altOpen);
            if(ck_open >= ck_close && ((ck_altOpen !='Invalid Date' && ck_close!='Invalid Date') &&( ck_altOpen>= ck_altClose ))){
                console.log("test=====")
                checkTime = true;
            }
            
            // Check if weekday-label is selected (restaurant is open) or not (closed)
            const isWeekdaySelected = $parent.find('#' + day + '-week-day').hasClass('selected');

            hours[day] = {
                open: _open.length === 7 ? _open : '',
                close: _close.length === 7 ? _close : '',
                altOpen: _altOpen.length === 7 ? _altOpen : '',
                altClose: _altClose.length === 7 ? _altClose : '',
                isClose: !isWeekdaySelected
            }
        })
        if(checkTime){
            toastr.error("Opening time must be less than closing time");
            return;
        }

        let venueId = $('#venueId').val();
        if(venueId){
            $.ajax({
                url: `/restaurantadmin/${venueId}/saveattributes`,
                method: 'POST',
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({data: hours, type: typeId}),
                success : function(data) {
                    if (data.code === 0){
                        fillDataAttributes();
                        saveLogRestaurant("Restaurant Hours",typeId,"","");
                        toastr.success("Save success");
                        $(document).scrollTop( $("#collapseRestrauntHours").offset().top - 40 );
                    }else{
                        toastr.error("Save failed");
                    }
                },
                fail: function(fail){
                    console.error(fail)
                },
                error: function(error){
                    console.error(error)
                }
            })
        }
    })

    function getAttributes(callback){
        $.ajax({
            url: `/restaurantadmin/${$('#venueId').val()}/getattributes`,
            method: 'GET',
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            data: {},
            success : function(data) {
                if (callback) callback(data);
            },
            fail: function(f){
                if (callback) callback();
                //console.log(f);
            },
            error: function(error){
                if (callback) callback();
                console.log(error);
            }
        });
    }

    function newDateSlipt(time){
        let date = new Date()
        let open = sliptTime(time);
        //let formattedHour = (open.hour == 12 ? 0 : open.hour) + ( open.ampm == "PM" ? 12 : 0 );
        //console.log("formattedHour===",formattedHour)
        date.setHours(open.hour);
        date.setMinutes(open.min);
        if(open.hour == 12 && open.ampm =="AM"){
           
            var dates = new Date(date);
            dates.setDate(dates.getDate() + 1);
            console.log("closeing hrs===",dates);
            return dates;
        }else{
            console.log("opning dates===",date)
            return date;
        }

        
    }

    function sliptTime(time) {
        let hour = 'Select';
        let min = '00';
        let ampm = 'AM';
        if(time) {
            let arrTime = _.split(_.replace(time,' ',''),':');
            hour = arrTime[0];
            if(hour.length == 1){
                hour = '0'+ hour;
            }
            min = arrTime[1].substring(0,arrTime[1].length-2);
            ampm = _.upperCase(arrTime[1].substring(arrTime[1].length-2));
        }
        return {hour, min, ampm}
    }

    function setTime(day, time, $parent) {
        if(time && day) {
            // Check if restaurant is closed for this day
            const isClose = time.isClose === true;
            
            let strHours = time.open || '';
            strHours = strHours ? time.close ? strHours + ' - ' + time.close : strHours : '';

            let strAltHours = time.altOpen || '';
            strAltHours = strAltHours ? time.altClose ? strAltHours + ' - ' + time.altClose : strAltHours : '';

            // If isClose is true, show as Closed regardless of hours data
            let strTime;
            if (isClose) {
                strTime = '<span>Closed</span>';
            } else {
                strTime = strHours ? strAltHours ? strHours + ', ' + strAltHours : strHours : strAltHours ? strAltHours : '<span>Closed</span>';
            }
            $parent.find('#text_'+ day +'_hours').html(strTime);

            // Only add 'selected' class if NOT closed
            if(!isClose && (strHours || strAltHours)) {
                $parent.find('#'+ day +'-week-day').addClass('selected');
            } else {
                $parent.find('#'+ day +'-week-day').removeClass('selected');
            }

            let open = sliptTime(time.open);
            $parent.find('#open_'+ day +'_from_hours').val(open.hour);
            $parent.find('#open_'+ day +'_from_minute').val(open.min);
            $parent.find('#open_'+ day +'_from_ampm').val(open.ampm);

            let altOpen = sliptTime(time.altOpen);
            $parent.find('#altOpen_'+ day +'_from_hours').val(altOpen.hour);
            $parent.find('#altOpen_'+ day +'_from_minute').val(altOpen.min);
            $parent.find('#altOpen_'+ day +'_from_ampm').val(altOpen.ampm);

            let close = sliptTime(time.close);
            $parent.find('#close_'+ day +'_to_hours').val(close.hour);
            $parent.find('#close_'+ day +'_to_minute').val(close.min);
            $parent.find('#close_'+ day +'_to_ampm').val(close.ampm);

            let altClose = sliptTime(time.altClose);
            $parent.find('#altClose_'+ day +'_to_hours').val(altClose.hour);
            $parent.find('#altClose_'+ day +'_to_minute').val(altClose.min);
            $parent.find('#altClose_'+ day +'_to_ampm').val(altClose.ampm);
        }
    }


    function fillDataAttributes() {
        $('.form-show-time').show();
        $('.form-edit-time').hide();
        
        // Clear all selected classes before loading data
        $('.weekday-label').removeClass('selected');
        
        let nameDay = today();
        getAttributes(function (data) {
            if (data && data.code === 0 && data.data && data.data.workingTime) {
                const InStore = data.data.workingTime["InStore"];
                if (InStore && Object.keys(InStore).length) {
                    Object.keys(InStore).forEach(day => {
                        const time = InStore[day];
                        const parent = $('#instore');
                        if (time) setTime(day, time, parent);
                    })
                } else {
//seems to be deuplicate of getTimeVenue   can be deleted                 getVenueHours();
                }

                const Pickup = data.data.workingTime["Pickup"];
                if (Pickup && Object.keys(Pickup).length > 0) {
                    Object.keys(Pickup).forEach(day => {
                        const time = Pickup[day];
                        const parent = $('#pickup');
                        if (time) setTime(day, time, parent);
                    })
                }

                const Delivery = data.data.workingTime["Delivery"];
                if (Delivery && Object.keys(Delivery).length > 0) {
                    Object.keys(Delivery).forEach(day => {
                        const time = Delivery[day];
                        const parent = $('#deliverys');
                                if (time) setTime(day, time, parent);
                    })
                }
            } else {
//seems to be deuplicate of getTimeVenue  can be deleted                  getVenueHours();
            }
        })
    }

    fillDataAttributes();
	
		/****** Delete restaurant Permanantly *****/
		$("#deleteRestaurantPermanantly").click(function(){
			if(venueId){
				Swal.fire({
                    title: "Are you sure ?",
                    text: "This will permanently delete this restaurant from the database, are you sure you want to proceed ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    confirmButtonColor: "#d9534f",
                }).then((result) => {
                    if (result.isConfirmed) {
                        $.ajax({
                            url: `/restaurantadmin/deleterestaurant/`,
                            method: 'POST',
                            dataType: 'json',
                            data: { venueId: venueId, isDeleted: true },
                            success: function (result) {
                                const message = result.message || "Successfully deleted!";
                                toastr.success(message);
                                Swal.close();
                                var origin = window.location.origin;
                                window.location.replace(origin);
                            },
                            error: function (error) {
                                const message = error.responseJSON.error || "Oops, something went wrong!";
                                toastr.error(message);
                            }
                        });
                    }
                });
                
			} else {
				toastr.error("Something Went wrong !!");
			}
		});	
		
		/***** Un-delete Restaurant(Platerate Admin) *****/
		$("#unDeleteRestaurant").click(function(){
			if(venueId){
				Swal.fire({
                    title: "Are you sure ?",
                    text: "You want this Restaurant Back ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    confirmButtonColor: "#d9534f",
                }).then((result) => {
                    if (result.isConfirmed) {
                        $.ajax({
                            url: '/restaurantadmin/deleterestaurant/',
                            method: 'POST',
                            dataType: 'json',
                            data: { venueId: venueId, isDeleted: false },
                            success: function (result) {
                                if (result.code == 0) {
                                    const message = result.message || "Successfully deleted!";
                                    toastr.success(message);
                                    Swal.close();
                                    var origin = window.location.origin;
                                    window.location.replace(origin);
                                } else {
                                    const message = "Restaurant Recovered Successfully!";
                                    toastr.success(message);
                                    Swal.close();
                                    window.location.reload();
                                }
                            },
                            error: function (error) {
                                const message = error.responseJSON.error || "Oops, something went wrong!";
                                toastr.error(message);
                            }
                        });
                    }
                });
                
			} else {
				toastr.error("Something Went wrong !!");
			}
		});	
/* can be deleted
    function getVenueHours () {
        $.ajax({
            url: `/venuehours/${$('#venueId').val()}`,
            method: 'GET',
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            data: {},
            success : function(data) {
                formatHours(data.hours || {});
            },
        });
    }
    function formatHours (data) {
        if(data.timeframes && data.timeframes.length) {
            data.timeframes.forEach((item) => {
                const hours = item.open && item.open.length ? item.open : [];
                let starts = hours[0]['start'];
                let ends = hours[0]['end'];
                if(item.days && item.days.length) {
                    item.days.forEach((day) => {
                        const dayWeek = DAYS_OF_THE_WEEK[day - 1];
                        let time = {
                            open: formatTime(starts),
                            close: formatTime(ends)
                        }
                        const parent = $('#instore');
                        setTime(dayWeek, time, parent);
                    })
                }
            })
        }
    }

    function formatTime(time) {
        let strTime = _.replace(time,'+','');
        let hour = 'Select';
        let min = '00';
        let ampm = 'AM';
        if(strTime && strTime.length == 4) {
            hour = strTime.substring(0,2);
            min = strTime.substring(2,4);
            ampm = "AM";
            if(Number(hour) > 12){
                hour = Number(hour) - 12;
                if(hour < 10) hour = '0'+hour;
                ampm = "PM";
            } else if(Number(hour) == 0) {
                hour = '12';
                if(time.includes('+')) ampm = "PM";
            }
        }
        return hour +':'+min+ampm
    }
    can be deleted till here
    */
});

$('.byob-days-container').on('click', function(e) {
        e.stopPropagation();
});

function change_zoom_cursor (elem){
    let img_link = $(elem).find('.item.active').find('img').attr('src');
    let cursor_icon, cursor_color;
    if(_.includes(img_link,'/images/')){
        cursor_icon = '\uf093';
        cursor_color = 'green'
    }else{
        cursor_icon = '\uf00e';
        cursor_color = '#FFCC00'
    }
    var canvas = document.createElement("canvas");
    canvas.width = 24;
    canvas.height = 24;
    //document.body.appendChild(canvas);
    var ctx = canvas.getContext("2d");
    ctx.fillStyle = cursor_color;
    ctx.font = "24px FontAwesome";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(cursor_icon, 12, 12);
    var dataURL = canvas.toDataURL('image/png')
    $(elem).css('cursor', 'url('+dataURL+'), auto');
}

